import React from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { NotificationManager } from 'react-notifications';
import { Loader } from '../../components/loader';
import Select from 'react-select';
import PhoneInput from 'react-phone-number-input';
import "react-phone-number-input/style.css";
import { fetchTerms, addTerm, deleteTerm, updateTerm } from '../../actions/contractTerms';

import moment from 'moment';
const $ = window.$;
class ContractTerms extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            loading: false,
            loadingDelete: false,
            terms: [],
            newTerm: '',
            editId: '',
            editTerm: ''
        }

    }

    changeVal = (event) => {
        this.setState({[event.target.name]: event.target.value})
    }

    addTerm = () => {
        if(this.state.newTerm.length > 0) {
            const data = {
                term: this.state.newTerm
            }
            this.props.addTerm(data);
        }        
    }

    toggleEdit = (id, term) => {
        if(this.state.editId === id) {
            this.setState({editId: ''});
            return true;
        }

        this.setState({editId: id, editTerm: term});
    }

    cancelEdit = () => {
        this.setState({editId: '', editTerm: ''});
    }

    saveEdit = (term) => {
        if(this.state.editTerm.length <= 0)
            return true;
        if(this.state.editTerm === term) {
            this.setState({loading: false, editId: '', editTerm: ''});
            return true;
        }
        const data = {
            term: this.state.editTerm
        }
        this.props.updateTerm(this.state.editId, data);
    }

    openConfirmDeleteModal = (id) => {
        this.setState({selectedId: id});
        $('#confirm_delete_modal').modal('show');
    }

    deleteTerm = () => {
        this.setState({loadingDelete: true});

        if(this.state.selectedId)
            this.props.deleteTerm(this.state.selectedId);
        else {
            NotificationManager.warning('This term not available.');
            this.setState({ loadingDelete: false });
        }
    }

    componentWillReceiveProps = (nextProps) => {
        if(this.props.data.newCTerm !== nextProps.data.newCTerm) {
            this.setState({loading: false, newTerm: ''});
            this.props.fetchTerms();
            NotificationManager.success("Term Added Successfully");
        }

        if(this.props.data.updatedCTerm !== nextProps.data.updatedCTerm) {
            this.setState({loading: false, editId: '', editTerm: ''});
            this.props.fetchTerms();
            NotificationManager.success("Term Updated Successfully");
        }

        if(this.props.data.selectedToDelete !== nextProps.data.selectedToDelete) {
            $('#confirm_delete_modal').modal('hide');
            this.setState({loadingDelete: false, selectedId: ''});
            this.props.fetchTerms();
            NotificationManager.success("Term Deleted Successfully");
        }
        if(this.props.data.newCTermError !== nextProps.data.newCTermError) {
            this.setState({loading: false, newTerm: ''});
            NotificationManager.error("Failed to add term.");
        }

        if(this.props.data.updatedCTermError !== nextProps.data.updatedCTermError) {
            this.setState({loading: false, editId: '', editTerm: ''});
            NotificationManager.error("Failed to update term");
        }

        if(this.props.data.selectedToDeleteError !== nextProps.data.selectedToDeleteError) {
            $('#confirm_delete_modal').modal('hide');
            this.setState({loadingDelete: false, selectedId: ''});
            NotificationManager.error("Failed to delete term.");
        }

        if(this.props.data.cTerms !== nextProps.data.cTerms) {
            this.setState({terms: nextProps.data.cTerms});
        }
    }

    componentDidMount() {
        this.props.fetchTerms();
    }

    render() {
        const { petShop } = this.props;
        return (
                
            <div className="row">
                <div className="col-xl-8 offset-xl-2">
                    <div className="m-form__section m-form__section--first row">
                        <div className="col-lg-12" style={{alignItems: 'center', display: 'flex'}}>
                            <div className="m-widget4 m-width-100-perc">
                                {this.state.terms.map(t => 
                                    <div key={t.id} className="m-widget4__item">
                                        {this.state.editId === t.id ? 
                                            <div className="col-lg-12" style={{display: 'inline-flex'}}>
                                                <input type="text" name="editTerm" onChange={this.changeVal} value={this.state.editTerm} className="form-control m-input mr-2" placeholder=""/>
                                                <button onClick={() => this.saveEdit(t.term)} className="btn btn-link btn-link-no-deco m-widget4__icon mr-2">
                                                    <i className="la la-check"></i>
                                                </button>
                                                <button onClick={this.cancelEdit} className="btn btn-link btn-link-no-deco m-widget4__icon">
                                                    <i className="la la-close"></i>
                                                </button>
                                            </div>
                                        :
                                            <React.Fragment>
                                                <div className="m-widget4__img m-widget4__img--icon">
                                                    <i className="la la-check"></i>
                                                </div>
                                                <div className="m-widget4__info">
                                                    <span className="m-widget4__text">
                                                        {t.term}
                                                    </span>
                                                </div>
                                                <div className="m-widget4__ext">
                                                    <button onClick={() => this.toggleEdit(t.id, t.term)} className="btn btn-link btn-link-no-deco m-widget4__icon">
                                                        <i className="la la-edit"></i>
                                                    </button>
                                                </div>
                                                <div className="m-widget4__ext">
                                                    <button onClick={() => this.openConfirmDeleteModal(t.id)} className="btn btn-link btn-link-no-deco m-widget4__icon">
                                                        <i className="la la-trash-o"></i>
                                                    </button>
                                                </div>
                                            </React.Fragment>
                                        }
                                    </div>                                    
                                )}
                            </div>
                        </div>
                        <div className="col-lg-12" style={{display: 'inline-flex'}}>
                            <input type="text" name="newTerm" onChange={this.changeVal} value={this.state.newTerm} className="form-control m-input mr-2" placeholder="Enter new term to be added"/>
                            <button onClick={this.addTerm} className="btn btn-primary m-btn m-btn--icon m-btn--pill">
                                <span>
                                    <i className="la la-save"></i>
                                    <span>Save</span>
                                </span>
                            </button>
                        </div>
                    </div>
                    <div className="modal fade" id="confirm_delete_modal" tabIndex="-1" role="dialog" aria-labelledby="ConfirmationModalLabel" aria-hidden="true">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title" id="exampleModalLabel">Confirm to delete term</h5>
                                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <p>If you choose to confirm this term will no loger be displayed in your contracts. Would you like to confirm?</p>
                                </div>
                                <div className="modal-footer">
                                {this.state.loadingDelete == false ?
                                    <div>
                                        <button type="button" className="btn btn-secondary m-btn--pill mx-2" data-dismiss="modal">Cancel</button>
                                        <button type="button" onClick={() => this.deleteTerm()} className="btn btn-primary m-btn--pill">Confirm</button>
                                    </div>
                                    :
                                    <div className="center-row">
                                        <Loader size={50} />
                                    </div>
                                }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const mapStateToProps = state => ({
    user: state.cognito.user,
    petShop: state.petShopReducer.currentPetshop,
    data: state.contractTermsReducer
});

const mapDispatchToProps = dispatch => ({
    fetchTerms: () => {
        dispatch(fetchTerms());
    },
    addTerm: (data) => {
        dispatch(addTerm(data));
    },
    deleteTerm: (id) => {
        dispatch(deleteTerm(id));
    },
    updateTerm: (id, data) => {
        dispatch(updateTerm(id, data));
    }
})

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ContractTerms));